import reportSubscriptionsService, { ENDPOINTS } from '@/services/reportSubscriptionsService';
import moduleFactory from '@/store/modules/moduleFactory';

const moduleStore = moduleFactory.build(ENDPOINTS, reportSubscriptionsService);

export default {
    namespaced: true,
    state: {
        ...moduleStore.state,
    },
    getters: {
        ...moduleStore.getters,
    },
    mutations: {
        ...moduleStore.mutations,
    },
    actions: {
        ...moduleStore.actions,
    },
};
